import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { fetchSiteSettings } from '../../../services/siteSettingsService';

const TrustSignals = () => {
  const [horizontalLogo, setHorizontalLogo] = useState(null);

  useEffect(() => {
    const loadLogos = async () => {
      const { horizontalLogo: logo } = await fetchSiteSettings();
      setHorizontalLogo(logo);
    };

    loadLogos();
  }, []);

  const footerLinks = {
    product: [
      { label: 'Features', path: '/features' },
      { label: 'Pricing', path: '/pricing' },
      { label: 'For Students', path: '/for-students' },
      { label: 'For Educators', path: '/registration' }
    ],
    resources: [
      { label: 'Help Center', path: '/help-center' },
      { label: 'More Shakespeare', path: '/more-shakespeare' }
    ],
    company: [
      { label: 'About Us', path: '/about-us' },
      { label: 'Contact', path: '/contact-us' },
      { label: 'Privacy Policy', path: '/privacy-policy' },
      { label: 'Terms of Service', path: '/terms-of-use' }
    ]
  };

  const footerSections = [
    { title: 'Product', links: footerLinks?.product?.map(item => ({ label: item?.label, href: item?.path })) },
    { title: 'Resources', links: footerLinks?.resources?.map(item => ({ label: item?.label, href: item?.path })) },
    { title: 'Company', links: footerLinks?.company?.map(item => ({ label: item?.label, href: item?.path })) }
  ];

  return (
    <footer className="w-full bg-surface-dark border-t border-white/10 py-12 lg:py-16 relative mt-auto">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              {horizontalLogo && (
                <img 
                  src={horizontalLogo} 
                  alt="BardPlay horizontal logo" 
                  className="h-6 w-auto"
                />
              )}
              <h3 className="text-2xl font-bold text-white">BardPlay</h3>
            </div>
            <p className="text-white/70 mb-6">
              Making Shakespeare accessible and enjoyable for modern learners through gamification and interactive learning.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors">
                <Icon name="Twitter" size={20} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors">
                <Icon name="Facebook" size={20} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors">
                <Icon name="Instagram" size={20} />
              </a>
            </div>
          </div>

          {/* Footer Links */}
          {footerSections?.map((section, index) => (
            <div key={index}>
              <h4 className="text-white font-semibold text-lg mb-4">{section?.title}</h4>
              <ul className="space-y-3">
                {section?.links?.map((link, idx) => (
                  <li key={idx}>
                    <a href={link?.href || '#'} className="text-white/70 hover:text-white transition-colors">
                      {link?.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © {new Date()?.getFullYear()} BardPlay. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-white/60 hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="text-white/60 hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="text-white/60 hover:text-white transition-colors">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default TrustSignals;